<template>
  <div class="pd-field" :class="{ 'pd-field--strong': strong }">
    <div class="pd-field__label">{{ label }}</div>
    <div class="pd-field__value" :class="{ 'pd-field__value--mono': mono }">
      <slot>
        <template v-if="isEmpty"
          ><span class="pd-field__empty">—</span></template
        >
        <template v-else>{{ value }}</template>
      </slot>
    </div>
  </div>
</template>
<script>
// Fila etiqueta/valor dentro de PaymentDetailSection. Sin valor muestra "—".
export default {
  name: "PaymentDetailField",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: null },
    mono: { type: Boolean, default: false },
    strong: { type: Boolean, default: false }
  },
  computed: {
    isEmpty() {
      return (
        this.value === null ||
        this.value === undefined ||
        String(this.value).trim() === ""
      );
    }
  }
};
</script>
<style scoped>
.pd-field {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: baseline;
  padding: 9px 0;
  border-bottom: 1px solid #f3f4f6;
}
.pd-field:last-child {
  border-bottom: none;
}
.pd-field__label {
  flex-shrink: 0;
  font-size: 13px;
  color: #6b7280;
}
.pd-field__value {
  min-width: 0;
  text-align: right;
  font-size: 14px;
  color: #111827;
  overflow-wrap: anywhere;
}
.pd-field__value--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
}
.pd-field__empty {
  color: #d1d5db;
}
.pd-field--strong .pd-field__label,
.pd-field--strong .pd-field__value {
  font-weight: 700;
  color: #111827;
}
</style>
